import classNames from "classnames";
import React from "react";
import { Dashes } from "./Dashes";

interface Props {
  className?: string;
  colorClass?: string;
  spaceClass?: string;
}

export const Separator: React.FC<Props> = ({
  className,
  colorClass = "text-lazer",
  spaceClass = "my-30px",
}) => {
  return (
    <div className={classNames(spaceClass, className)}>
      <Dashes className={colorClass} />
    </div>
  );
};
